import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userEmail: null,
  userGroup: null,
  authState: "SignIn",
  firstName: null,
  lastName: null,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserEmail: (state, action) => {
      state.userEmail = action.payload;
    },
    setUserGroup: (state, action) => {
      state.userGroup = action.payload;
    },
    setAuthState: (state, action) => {
      state.authState = action.payload;
    },
    setUserName: (state, action) => {
      const { firstName, lastName } = action.payload || {};
      if (firstName !== undefined) state.firstName = firstName;
      if (lastName !== undefined) state.lastName = lastName;
    },
  },
});

export const { setUserEmail, setUserGroup, setAuthState, setUserName } =
  AuthSlice.actions;

export const selectUserEmail = (state) => state.auth.userEmail;
export const selectUserGroup = (state) => state.auth.userGroup;
export const selectAuthState = (state) => state.auth.authState;
export const selectFirstName = (state) => state.auth.firstName;
export const selectLastName = (state) => state.auth.lastName;

export default AuthSlice.reducer;
